import { createSelector } from 'reselect';
import { getIsDamzPageOpen } from '@wix/da-shared-react/pkg/SiteHeader/redux/selectors';

export const getIsDamzClosed = createSelector([getIsDamzPageOpen], isDamzOpen => {
  return !isDamzOpen;
});
